import React from 'react';
import { EligibilityStatus } from 'types/uwService';
import { TagStyled } from './styles';
import { DATA_TEST_IDS } from '../constants';

interface Props {
  status: EligibilityStatus;
}

export enum StatusTagTypes {
  ELIGIBLE = 'Eligible',
  UPDATED_RATES = 'Updated Rates',
  NOT_ELIGIBLE = 'Not Eligible',
  OVERRIDE = 'Overridden Rates',
}

const UwStatusTag: React.FC<Props> = ({ status }) => {
  return (
    <TagStyled $status={StatusTagTypes[status]} data-test-id={DATA_TEST_IDS.UW_STATUS_TAG}>
      <span>{StatusTagTypes[status]}</span>
    </TagStyled>
  );
};

export default UwStatusTag;
